import { cn } from '@/lib/utils';
import { fmtMoney } from './format';

const SIZE = {
  hero: 'text-4xl font-bold',
  figure: 'text-2xl font-bold',
  row: 'text-base font-semibold',
  small: 'text-sm font-medium'
} as const;

/** Số tiền chữ slab, thẳng cột. `tone="in"` = thu nhập (xanh lá); còn lại màu chữ thường — số âm không đỏ. */
export default function Money({ value, size = 'row', tone, compact, plus, unit = true, className }: {
  value: number; size?: keyof typeof SIZE; tone?: 'in' | 'muted'; compact?: boolean; plus?: boolean; unit?: boolean; className?: string;
}) {
  return (
    <span className={cn('font-slab num whitespace-nowrap', SIZE[size], tone === 'in' && 'text-good', tone === 'muted' && 'text-muted-foreground', className)}>
      {fmtMoney(value, { compact, plus })}{unit && !compact && <span className="ml-0.5 font-sans text-sm font-medium text-muted-foreground">đ</span>}
    </span>
  );
}
